import { Ref, useCallback, useState } from 'react';
import Select, { ValueType as Value } from '@atlaskit/select';

import { Field } from '@atlaskit/form';
import { FormSelectOption } from './form-select-option';
import { formField } from './form-field.styles';
import { Message } from '../constants/types';
import { SpotlightTarget } from '.';
import { useInteractiveBoardStore } from '../state';
import { Steps } from '../constants/ui';

export const FormSelect = ({
  id,
  name,
  label,
  forwardRef,
  required,
  disabled,
  options,
  step,
  defaultValue,
  simplifiedView = false,
  assetResolver,
  onStepComplete,
  autoFocus
}: FormSelectProps) => {
  const complete = useCallback(
    onStepComplete
      ? () => onStepComplete()
      : () => console.warn('onStepComplete is not defeined.'),
    [onStepComplete]
  );

  const [hideDetails, setHideDetails] = useState(simplifiedView);
  const [lastSelectedOn, setLastSelectedOn] = useState('');
  const [{ step: currentStep }, { setSpotlightVisibility }] =
    useInteractiveBoardStore();

  return (
    <div css={formField}>
      <Field<Value<Option>>
        name={name}
        label={label}
        isDisabled={disabled}
        defaultValue={defaultValue}
      >
        {({ fieldProps }) => (
          <SpotlightTarget name={name}>
            <Select
              {...fieldProps}
              id={id}
              // FIXME: Fix the type of forwardRef
              // @ts-ignore-next-line
              ref={forwardRef}
              inputId={id}
              onMenuOpen={() => {
                if (currentStep == step) {
                  // only hide spotlight if this is the current step.
                  void setSpotlightVisibility(false);
                }

                setHideDetails(false);
              }}
              onMenuClose={() => {
                void setSpotlightVisibility(true);
                setLastSelectedOn(new Date().toISOString());
              }}
              onBlur={() => complete()}
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus={autoFocus} //ok when in modal
              blurInputOnSelect
              options={options}
              required={required}
              menuPlacement="auto"
              formatOptionLabel={(option) => (
                <FormSelectOption
                  option={option}
                  assetResolver={assetResolver}
                  simplifiedView={hideDetails}
                  lastSelectedOn={lastSelectedOn}
                />
              )}
            />
          </SpotlightTarget>
        )}
      </Field>
    </div>
  );
};

type FormSelectProps = {
  id: string;
  name: string;
  label: string;
  forwardRef?: Ref<HTMLSelectElement>;
  required: boolean;
  options: Option[];
  step?: Steps;
  defaultValue?: Option;
  assetResolver?: (
    value: string,
    messages: Message,
    includeLabel: boolean
  ) => JSX.Element;
  disabled?: boolean;
  simplifiedView?: boolean;
  onStepComplete?: () => void;
  autoFocus?: boolean;
};

export type Option = {
  label: string;
  value: string;
};
